module.exports = __webpack_public_path__ + "img/product1.fc054fe7.png";